(() => {
  function init(root = document) {
    root.querySelectorAll('[data-modelpod-motion]').forEach(stage => {
      if(stage.dataset.motionReady)return;
      stage.dataset.motionReady='true';
      const videos=[...stage.querySelectorAll('[data-sequence-video]')];
      if(!videos.length)return;
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      let active=0, visible=true, request=0, failed=false;
      const pause=()=>{request++;videos.forEach(v=>v.pause());};
      async function play(){
        if(reduced.matches||document.hidden||!visible||failed)return;
        const v=videos[active],token=++request;
        v.muted=true;v.loop=false;
        try {await v.play();if(token!==request){if(document.hidden||!visible||reduced.matches)v.pause();return;}stage.classList.add('has-video');videos.forEach((item,i)=>{item.classList.toggle('is-active',i===active);item.setAttribute('aria-hidden',String(i!==active));});}
        catch(error){if(token===request&&error.name!=='AbortError'){failed=true;stage.classList.remove('has-video');}}
      }
      videos.forEach((v,i)=>{
        v.addEventListener('ended',()=>{if(i!==active)return;active=(active+1)%videos.length;videos[active].currentTime=0;void play();});
        v.addEventListener('error',()=>{if(i===active){failed=true;pause();stage.classList.remove('has-video');}});
      });
      document.addEventListener('visibilitychange',()=>document.hidden?pause():void play());
      reduced.addEventListener('change',()=>{if(reduced.matches){pause();stage.classList.remove('has-video');}else void play();});
      if('IntersectionObserver' in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;visible?void play():pause();},{threshold:.1}).observe(stage);
      void play();
    });
    root.querySelectorAll('[data-mp-image]').forEach(button=>{
      if(button.dataset.galleryReady)return;button.dataset.galleryReady='true';
      button.addEventListener('click',()=>{const scope=button.closest('.mp-release'),image=scope.querySelector('#mp-main-image');if(!image)return;image.removeAttribute('srcset');image.src=button.dataset.mpImage;image.alt=button.dataset.mpAlt;scope.querySelector('#mp-image-caption').textContent=button.dataset.mpAlt;scope.querySelectorAll('[data-mp-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});
    });
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
